export default __webpack_public_path__ + "static/media/lifestyle-disease.28e883fe.png";